import React, { useEffect, useState } from 'react'
import { FaUsers } from "react-icons/fa";
import { PiBackpackBold } from "react-icons/pi";
import { GoRocket } from "react-icons/go";
import { LuNotebook } from "react-icons/lu";
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';

const CouponList = () => {

  const [CouponUser, setCouponUser] = useState([]);
    const navigate = useNavigate();
  
    useEffect(() => {
  const fetchData = async () => {
    try {
      const response = await axios.get(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_new_coupon"
      );

      if (response.data?.success === "1") {
        setCouponUser(response.data.data || []);
      } else {
        setCouponUser([]);
      }
    } catch (error) {
      console.error("Error fetching coupons:", error);
      setCouponUser([]);
    }
  };

  fetchData();
}, []);


const deleteUser = async (couponId) => {
  try {
    const response = await axios.post(
      "https://cyberathon.com/multivendor/index.php/Api/Master_controller/delete_new_coupon",
      { coupon_id: couponId },
      { headers: { "Content-Type": "application/json" } }
    );

    if (response.data?.success === "1") {
      setCouponUser((prev) =>
        prev.filter((item) => item.coupon_id !== couponId)
      );
      toast.success(response.data.message || "Coupon deleted successfully");
    } else {
      toast.error(response.data.message || "Delete failed");
    }
  } catch (error) {
    console.error("Delete error:", error);
    toast.error("Failed to delete coupon");
  }
};





  return (
<div className="page-content">
  {/* Start Container Fluid */}
  <div className="container-fluid">
    {/* ========== Page Title Start ========== */}
    <div className="row">
      <div className="col-12">
        <div className="page-title-box">
          <h4 className="mb-0 fw-semibold">Coupons List</h4>
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <a href="javascript: void(0);">Coupons</a>
            </li>
            <li className="breadcrumb-item active">Coupons List</li>
          </ol>
        </div>
      </div>
    </div>
    {/* ========== Page Title End ========== */}
    <div className="row">
      <div className="col-md-6 col-xl-3">
        <div className="card bg-primary-subtle">
          <div className="card-body">
            <h4 className="mb-1">4 Coupons</h4>
            <p>Small nice summer coupons pack</p>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h3 className="text-primary fw-semibold">$140.00</h3>
                <p className="mb-0">Duration : 1 Year</p>
              </div>
              <div>
                <a href="#!" className="btn btn-primary">
                  Buy Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-6 col-xl-3">
        <div className="card bg-info-subtle">
          <div className="card-body">
            <h4 className=" mb-1">8 Coupons</h4>
            <p className="">Medium nice summer coupons pack</p>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h3 className="text-info fw-semibold">$235.00</h3>
                <p className="mb-0">Duration : 1 Year</p>
              </div>
              <div>
                <a href="#!" className="btn btn-info">
                  Buy Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-12 col-xl-6">
        <div className="card bg-primary-subtle overflow-hidden z-1">
          <div className="card-body">
            <div className="d-flex flex-wrap rounded-3 gap-2 align-items-center">
              <iconify-icon
                icon="solar:bag-smile-bold-duotone"
                className="fs-48 text-primary"
              />
              <div className="d-block">
                <h3 className=" fw-semibold">
                  30% Special discounts for customers
                </h3>
                <h5 className=" mb-0">25 November - 2 December</h5>
              </div>
              <div className="ms-auto"></div>
            </div>
          </div>
          <div className="card-footer pt-2">
            <a href="#!" className="btn btn-primary fw-semibold">
              View Plan
            </a>
          </div>
          <div className="position-absolute top-100 start-100 translate-middle z-n1 opacity-75">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              xmlnsXlink="http://www.w3.org/1999/xlink"
            //   xmlns:svgjs="http://svgjs.dev/svgjs"
              viewBox="0 0 800 800"
              height={400}
              width={400}
            >
              <defs>
                <linearGradient
                  x1="50%"
                  y1="0%"
                  x2="50%"
                  y2="100%"
                  id="wwwhirl-grad"
                >
                  <stop stopColor="#ff6c2f" stopOpacity={1} offset="45%" />
                  <stop stopColor="#ff6c2f" stopOpacity={1} offset="100%" />
                </linearGradient>
              </defs>
              <g
                strokeWidth={2}
                stroke="url(#wwwhirl-grad)"
                fill="none"
                strokeLinecap="round"
              >
                <path
                  d="M37.00000251770027 421.0787426918496C50.75000289917 406.0224922741403 75.50000358581553 351.9024907726754 103.000004348755 348.80874068684466C130.50000511169446 345.714990601014 141.5000054168703 406.6412422913064 169.00000617980973 406.22874227986233C196.5000069427492 405.8162422684182 207.50000724792503 339.4037404259194 235.00000801086446 346.82874063191304C262.500008773804 354.2537408379067 273.5000090789798 439.3937431999673 301.0000098419193 441.8687432686319C328.50001060485874 444.3437433372964 339.5000109100345 361.8024910473336 367.000011672974 358.7087409615029C394.50001243591345 355.6149908756722 405.5000127410893 426.3999928394784 433.0000135040287 427.0187428566445C460.5000142669682 427.6374928738107 471.50001457214404 363.3287410896767 499.0000153350834 361.67874104390035C526.5000160980228 360.02874099812396 537.5000164031987 420.1299926655282 565.0000171661382 419.09874263691796C592.5000179290777 418.06749260830776 603.5000182342535 349.5099907062996 631.000018997193 356.72874090657126C658.5000197601325 363.94749110684285 669.5000200653083 453.33624358677764 697.0000208282477 453.7487435982217C724.5000215911871 454.1612436096658 749.2500222778326 378.50874151081933 763.0000226593024 358.7087409615029 "
                  transform="rotate(99, 400, 400)"
                />
                <path
                  d="M48.00000244140632 420.43999499405265C61.33333614464971 405.8399945890012 85.3333368104878 353.35999313303523 112.00000421697456 350.3599930498055C138.6666716234613 347.3599929665757 149.33333858605602 406.43999460564714 176.00000599254278 406.03999459454985C202.66667339902952 405.6399945834525 213.33334036162427 341.239992796787 240.000007768111 348.4399929965384C266.6666751745978 355.6399931962899 277.3333421371925 438.1999954867729 304.00000954367925 440.5999955533567C330.66667695016605 442.9999956199405 341.3333439127607 362.9599933993705 368.00001131924745 359.9599933161407C394.66667872573424 356.95999323291096 405.33334568832896 425.5999951372079 432.00001309481576 426.1999951538538C458.66668050130244 426.79999517049976 469.3333474638972 364.4399934404305 496.0000148703839 362.8399933960413C522.6666822768707 361.23999335165206 533.3333492394653 419.51999496852886 560.0000166459522 418.51999494078564C586.666684052439 417.5199949130424 597.3333510150337 351.0399930686709 624.0000184215204 358.0399932628737C650.6666858280073 365.03999345707643 661.3333527906019 451.71999586186166 688.0000201970887 452.11999587295895C714.6666876035754 452.51999588405624 738.6666882694134 379.15999384881115 752.0000219726569 359.9599933161407 "
                  transform="rotate(96, 400, 400)"
                />
                
              </g>
            </svg>
          </div>
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-xl-12">
        <div className="card">
          <div className="d-flex card-header justify-content-between align-items-center">
            <div>
              <h4 className="card-title">All Product List</h4>
              
            </div>
            <div className="dropdown">
              <Link to="/coupon-list-add" className="btn btn-sm btn-primary">
                 Add Coupan
                </Link>
              <a
                href="#"
                className="dropdown-toggle btn btn-sm btn-outline-light rounded"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                This Month
              </a>
              <div className="dropdown-menu dropdown-menu-end">
                {/* item*/}
                <a href="#!" className="dropdown-item">
                  Download
                </a>
                {/* item*/}
                <a href="#!" className="dropdown-item">
                  Export
                </a>
                {/* item*/}
                <a href="#!" className="dropdown-item">
                  Import
                </a>
              </div>
            </div>
          </div>
          <div>
            <div className="table-responsive">
              <table className="table align-middle mb-0 table-hover table-centered">
                <thead className="bg-light-subtle">
                  <tr>
                    <th style={{ width: 20 }}>
                      <div className="form-check ms-1 fs-16">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="customCheck1"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="customCheck1"
                        />
                      </div>
                    </th>
                    <th>Coupan Name</th>
                    <th>Price</th>
                    <th>Discount</th>
                    <th>Description</th>
                    <th>Code</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                {Array.isArray(CouponUser) && CouponUser.map((user, index) => (
                    <tr key={index}>
                      <td>
                        <div className="form-check ms-1 fs-16">
                          <input type="checkbox" className="form-check-input" />
                        </div>
                      </td>

                      <td>
                        <a className="text-dark fw-medium fs-15">
                          {user.coupon_name}
                        </a>
                      </td>

                      <td>{user.minimum_order_value}</td>

                      <td>
                        {user.discount_type === "percentage"
                          ? `${user.discount_value}%`
                          : `₹${user.discount_value}`}
                      </td>

                      <td>{user.description}</td>

                      <td>{user.coupon_code}</td>

                      <td>{user.start_date}</td>

                      <td>{user.expiry_date}</td>

                      <td>
                        <span
                          className={`badge ${
                            user.status === "active"
                              ? "bg-success-subtle text-success"
                              : "bg-danger-subtle text-danger"
                          } py-1 px-2`}
                        >
                          {user.status}
                        </span>
                      </td>

                      <td>
                        <div className="d-flex gap-2">
                          <Link
                            to={`/coupon-list-view/${user.coupon_id}`}
                            className="btn btn-light btn-sm"
                          >
                            <i className="fa-solid fa-eye fs-18"></i>
                          </Link>

                          <Link
                            to={`/coupon-list-edit/${user.coupon_id}`}
                            className="btn btn-soft-primary btn-sm"
                          >
                            <i className="fa-solid fa-pencil fs-18"></i>
                          </Link>

                          <span
                            onClick={() => deleteUser(user.coupon_id)}
                            className="btn btn-soft-danger btn-sm"
                          >
                            <i className="fa-solid fa-trash fs-18"></i>
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))}

                </tbody>
              </table>
            </div>
            {/* end table-responsive */}
          </div>
          <div className="card-footer border-top">
            <nav aria-label="Page navigation example">
              <ul className="pagination justify-content-end mb-0">
                <li className="page-item">
                  <a className="page-link" href="javascript:void(0);">
                    Previous
                  </a>
                </li>
                <li className="page-item active">
                  <a className="page-link" href="javascript:void(0);">
                    1
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link" href="javascript:void(0);">
                    2
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link" href="javascript:void(0);">
                    3
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link" href="javascript:void(0);">
                    Next
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* End Container Fluid */}
  {/* ========== Footer Start ========== */}
  <footer className="footer">
    <div className="container-fluid">
      <div className="row">
        <div className="col-12 text-center">
          © Venton. Crafted by{" "}
          <iconify-icon
            icon="iconamoon:heart-duotone"
            className="fs-18 align-middle text-danger"
          />{" "}
          <a href="" className="fw-bold footer-text" target="_blank">
            Techzaa
          </a>
        </div>
      </div>
    </div>
  </footer>
  {/* ========== Footer End ========== */}
</div>


  )
}

export default CouponList
